import type { ChangeEvent } from 'react'

import { Checkbox } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

export interface ReviewTransferAgreementProps {
  /**
   * Is checked.
   */
  isChecked?: boolean
  /**
   * Custom className.
   */
  className?: string
  /**
   * On click.
   */
  onCheckboxChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export const ReviewTransferAgreement: React.FC<
  ReviewTransferAgreementProps
> = ({ isChecked, onCheckboxChange, className }) => {
  const { t } = useTranslation('ace')

  return (
    <div className={className}>
      <Checkbox
        checked={isChecked}
        className="mt-2"
        data-testid="ace-review-transfer-agreement"
        helpText={t('sendOnchain.reviewTransfer.agreement.helpText')}
        label={t('sendOnchain.reviewTransfer.agreement.label')}
        onChange={onCheckboxChange}
      />
    </div>
  )
}
